import React, { useEffect, useState } from "react";
import { getTopper } from "../Service/Api"; 
import Header from "../components/Header";
import Footer from "../components/Footer"; 
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from "react-lazyload";

const TopperX = () => {
   const [data, setData] = useState([]);
   const [filterData, setFilteredData] = useState([]);
   const [selectedYear, setSelectedYear] = useState("");
   const [yearRanges, setYearRanges] = useState([]);
   const [searchQuery, setSearchQuery] = useState("");

   // Fetch the topper data
   useEffect(() => {
      const fetchData = async () => {
         const galleryData1 = await getTopper();
         const galleryData = galleryData1.filter((item) => item.class === 'X');
         setData(galleryData);

         // Extract unique years and sort them in descending order
         const uniqueYears = Array.from(
            new Set(galleryData.map((item) => item.sessionYear))
         ).sort((a, b) => b.localeCompare(a)); // Sort by year descending

         console.log("Unique Years:", uniqueYears);
         setYearRanges(uniqueYears);

         // Automatically select the most recent year with available data
         if (uniqueYears.length > 0) {
            setSelectedYear(uniqueYears[0]);
         }

         setFilteredData(galleryData); // Initialize filteredData with all data
      };
      fetchData();
   }, []);

   // Apply filter based on selected year and search query
   useEffect(() => {
      // Filter data based on selected year
      let filteredData = data.filter((item) => item.sessionYear === selectedYear);

      // Apply search filter
      if (searchQuery) {
         filteredData = filteredData.filter((item) =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
         );
      }

      // Sort by division
      filteredData.sort((a, b) => parseFloat(b.division) - parseFloat(a.division));

      setFilteredData(filteredData);
   }, [selectedYear, searchQuery, data]);

   return (
      <>
         <Header />
         <Breadcrumb breadcrumbName="Topper X/ICSE Toppers" mid="School Toppers" />

         <div className="innerSection">
            <div className="container">
               <div className="row tabs-dynamic">
                  <div className="col-md-6">
                     <div className="month-selection">
                        <select
                           value={selectedYear}
                           onChange={(e) => setSelectedYear(e.target.value)}
                           className="yearSelection"
                        >
                           {yearRanges.map((yr) => (
                              <option key={yr} value={yr}>{yr}</option>
                           ))}
                        </select>
                     </div>
                  </div>
                  <div className="col-md-6">
                     <div className="searchBox">
                        <input
                           type="text"
                           id="myInput"
                           name="name"
                           value={searchQuery}
                           onChange={(e) => setSearchQuery(e.target.value)}
                           placeholder="Search Here.."
                        />
                     </div>
                  </div>
               </div>
               <div className="row">
                  {filterData.length > 0 ? (
                     filterData.map((item, index) => (
                        <div className="col-md-3" key={index}>
                           <div className="topper-section services-style-current-theme text-center mb-lg-50 innertopper">
                              <div className="topper-service">
                                 <div className="thumb">
                                  <LazyLoad>  {item.attachments.length > 0 ? (
                                       <img className="img-fluid" src={`https://webapi.entab.info/api/image?url=${item.attachments}`} alt="St Mary school Mirzapur" />
                                    ) : (
                                       <img className="img-fluid" src="https://webapi.entab.info/api/image/SMSMU/public/Images/dummy.jpg" alt="St Mary school Mirzapur" />
                                    )}</LazyLoad>
                                 </div>
                                 <div className="details clearfix">
                                    <h3 className="sub_title">  {item?.name} </h3>
                                    <p>{item?.stream}</p>
                                    <p>Marks: {item?.division}</p>
                                 </div>
                              </div>
                           </div> 
                        </div>
                     ))
                  ) : (
                     <div className="col-md-3">
                        <div className="topper-section services-style-current-theme text-center mb-lg-50 innertopper">
                           <div className="topper-service">
                              <div className="thumb">
                                 <LazyLoad><img className="img-fluid" src="https://webapi.entab.info/api/image/SMSMU/public/Images/dummy.jpg" alt="St Mary school Mirzapur" /></LazyLoad>
                              </div>
                              <div className="details clearfix">
                                 <h3 className="sub_title"> Student Name </h3>
                                 <p>Stream</p>
                                 <p>Marks</p>
                              </div>
                           </div>
                        </div> 
                     </div>
                  )}
               </div>
            </div>
         </div>
         <Footer />
      </>
   );
};

export default TopperX;
